import React from 'react';
import { Box, Typography } from '@mui/material';
import { IconType } from 'react-icons';

export interface PlanValuePropProps {
	title: string;
	description?: string;
	icon?: IconType;
}
const PlanValueProp = (props: PlanValuePropProps) => {
	const { title, description, icon: Icon } = props;

	return (
		<Box sx={{ display: 'flex', flexDirection: 'row', mb: 5 }}>
			<Box
				sx={{
					background: (theme) => theme.palette.background.paper,
					width: 42,
					height: 42,
					borderRadius: '4px',
					border: (theme) => `1px solid ${theme.palette.border.paper}`,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginRight: 2,
				}}
			>
				{!!Icon ? <Icon /> : null}
			</Box>
			<Box>
				<Typography variant="body1" sx={{ fontWeight: 500 }}>
					{title}
				</Typography>
				<Typography variant="body1" color="secondary">
					{description}
				</Typography>
			</Box>
		</Box>
	);
};

export default PlanValueProp;
